export abstract class Filter {

    constructor(public value : string = "") {

    }

    reset() {
       this.onReset();
       this.value = "";
    }

    protected abstract onReset() : void;


}